package dev.lingvo.ops.state

enum class OpsKeyState { NONE, STORED, UNREADABLE }

fun keyState(hasKey: Boolean, unreadable: Boolean): OpsKeyState = when {
    !hasKey -> OpsKeyState.NONE
    unreadable -> OpsKeyState.UNREADABLE
    else -> OpsKeyState.STORED
}

fun overrideNote(mode: String, hasKey: Boolean, unreadable: Boolean): String? = when {
    mode.equals("INHERITED", ignoreCase = true) -> null
    hasKey && unreadable -> "This project stores its own provider key, but the API cannot decrypt it; check the deployment secret."
    hasKey -> "This project stores its own provider key."
    else -> "This project override does not store a provider key."
}
